import '../css'

addEventListener('change', ({ target }) => {
  if (target.matches('.checklist input[type="checkbox"]')) {
    const form = target.closest('form')
    const { action, method } = form

    fetch(action, {
      method,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(resp => {
        if (resp.ok) return resp.text()
      })
      .then(text => {
        document.querySelector('.checklist').innerHTML = text
      })
  }
})
